import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddCareteamSuccessIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.4976 24.5021C68.062 42.8068 62.8206 56.6083 47.1726 64.8731C37.2226 70.1285 25.767 73.9868 19.8893 83.5823C-1.51919 118.532 44.1152 147.28 73.4972 113C98.4156 83.9275 136.624 151.34 172.997 96.5C205.496 47.5007 138.997 -24.0008 87.4976 24.5021Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 51,
			y: 48,
			width: 98,
			height: 60,
			rx: 4,
			fill: "url(#paint0_linear_20469_32800)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51 51.5696C51 50.007 52.7116 49.0479 54.0443 49.8639L142.947 104.294C144.669 105.349 143.922 108 141.903 108H55C52.7909 108 51 106.209 51 104V51.5696Z",
			fill: "url(#paint1_linear_20469_32800)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149 51.5696C149 50.007 147.288 49.0479 145.956 49.8639L54.0263 106.147C53.1654 106.674 53.539 108 54.5485 108H145C147.209 108 149 106.209 149 104V51.5696Z",
			fill: "url(#paint2_linear_20469_32800)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 92,
			cy: 122,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 39,
			cy: 34,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.334 48.0001C113.334 55.3639 107.364 61.3334 100 61.3334C92.6365 61.3334 86.667 55.3639 86.667 48.0001C86.667 40.6363 92.6365 34.6667 100 34.6667C107.364 34.6667 113.334 40.6363 113.334 48.0001Z",
			fill: "#42AF60",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M105.689 42.9426C106.089 43.3235 106.105 43.9565 105.724 44.3564L98.1048 52.3564C97.916 52.5546 97.6543 52.6667 97.3806 52.6667C97.107 52.6667 96.8452 52.5546 96.6565 52.3564L93.6089 49.1564C93.228 48.7565 93.2434 48.1235 93.6434 47.7426C94.0433 47.3617 94.6763 47.3772 95.0571 47.7771L97.3806 50.2168L104.276 42.9771C104.656 42.5772 105.289 42.5617 105.689 42.9426Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_20469_32800",
				x1: 54.7373,
				y1: 51.0508,
				x2: 102.084,
				y2: 129.121,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_20469_32800",
				x1: 54.7373,
				y1: 51.0508,
				x2: 102.084,
				y2: 129.121,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_20469_32800",
				x1: 145.263,
				y1: 51.0508,
				x2: 97.9157,
				y2: 129.121,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgAddCareteamSuccessIcon);
export { ForwardRef as ReactComponent };
